<template>
  <div>
    <nav>
      <div class="container">
        <div class="nav-top clearfix">
          <div class="mobile-menu" v-if="isMobile">
            <div class="left">
              <button class="navbar-toggle" type="button" @click="toggleMenu">
                <span class="sr-only">Toggle navigation</span><i class="fa fa-bars"></i>
              </button>
            </div>
          </div>
 
          <div class="logo center" style='margin-bottom : 16px'>
            <a href="/" class="navbar-brand">
              <img src="../../public/assets/images/seedjung_logo_2.png" alt="Logo" :style="{ maxWidth: isMobile ? '120px' : '160px', height: 'auto' }" />
            </a>
          </div>
 
          <div class="head_top_auth pull-right" style="margin-bottom:5px" v-if="isMobile">
            <template v-if="isLoggedIn">
              <a href="/" @click.prevent="logout" class="login-text" style="margin-left: 10px;">로그아웃</a>
            </template>
            <template v-else>
              <span class="login-text"><router-link to="login">로그인</router-link></span>
            </template>
          </div>
 
          <div class="head_top_auth pull-right" style="margin-top:10px" v-else>
            <template v-if="isLoggedIn">
              <span>{{ nickname }}님</span>
              <router-link to="/mypage" class="mypage-link">마이페이지</router-link>
              <a href="/" @click.prevent="logout" class="login-text" style="margin-left: 10px;">로그아웃</a>
            </template>
            <template v-else>
              <router-link to="login" class="login-link">로그인</router-link>
              <router-link to="regist" class="signup-btn">간편가입</router-link>
            </template>
          </div>
        </div>
      </div>
      
      <!-- PC 버전 -->
      <div class="main-nav" :class="{ 'show': isMenuOpen }">
        <div class="container">
          <div class="minilogo" v-if="isMobile">
            <a href="/" class="navbar-brand"><img src="../../public/assets/images/seedjung_logo_2.png" alt="Logo" /></a>
          </div>
 
          <ul class="nav" :class="{ 'nav-justified': !isMobile }" v-if="!isMobile">
            <li><router-link :to="{ path: '/' }" class="">HOME</router-link></li>
            <li class="dropdown"><a>시드정 소개</a>
              <ul class="dropdown-menu" :class="{ 'show': isDropdownOpen }">
                <li>
                  <router-link :to="{ path: '/about' }">시드정 소개</router-link>
                </li>
                <li>
                  <router-link :to="{ path: '/counselor' }">상담사 소개</router-link>
                </li>
              </ul>
            </li>
            <li>
              <a href="/#service">칼럼</a>
            </li>
            <li>
              <router-link :to="{ path: '/consulting' }">상담신청</router-link>
            </li>
            <li>
              <router-link :to="{ path: '/review' }">상담후기</router-link>
            </li>
            <!-- 블로그 -->
            <!-- <li>
              <a href="https://blog.naver.com/alscofld95" target="_blank" rel="noopener noreferrer">상담후기</a>
            </li> -->
            <!-- 블로그 -->
            <li>
              <router-link :to="{ path: '/inquiry' }">문의</router-link>
            </li>
          </ul>
 
          <!-- 모바일 버전 -->
          <ul class="nav" :class="{ 'nav-justified': isMobile }" v-else>
            <li><router-link :to="{ path: '/' }" :class="{ 'active': currentMenu === 'home' }" @click="toggleMenu; setCurrentMenu('home')">HOME</router-link></li>
            <li v-if="isLoggedIn">
              <router-link :to="{ path: '/mypage' }" :class="{ 'active': currentMenu === 'mypage' }" @click="toggleMenu; setCurrentMenu('mypage')">마이페이지</router-link>
            </li>            
            <li class="dropdown">
              <a :class="{ 'active': currentMenu === 'about' }" @click.prevent="toggleSubMenu('about'); setCurrentMenu('about');">시드정 소개</a>
              <ul class="dropdown-menu" :class="{ 'show': isAboutSubmenuOpen }">
                <li><router-link :to="{ path: '/about' }" @click="toggleMenu; setCurrentMenu('about')" >시드정 소개</router-link></li>
                <li><router-link :to="{ path: '/counselor' }" @click="toggleMenu(); setCurrentMenu('service')">상담사 소개</router-link></li>
              </ul>
            </li>
            <li><a :class="{ 'active': currentMenu === 'column' }" href="/#service" @click="toggleMenu(); setCurrentMenu('column')">칼럼</a></li>
            <!-- 상담신청 메뉴 추가 -->
            <li><router-link :to="{ path: '/consulting' }" :class="{ 'active': currentMenu === 'consulting' }" @click="toggleMenu; setCurrentMenu('consulting')">상담신청</router-link></li>
            <li><router-link :to="{ path: '/review' }" :class="{ 'active': currentMenu === 'review' }" @click="toggleMenu; setCurrentMenu('review')">상담후기</router-link></li>
            <!-- 블로그 -->
            <!-- <li>
              <a 
                href="https://blog.naver.com/alscofld95" 
                target="_blank" 
                rel="noopener noreferrer"
                :class="{ 'active': currentMenu === 'review' }" 
                @click="toggleMenu; setCurrentMenu('review')"
              >상담후기</a>
            </li> -->
            <!-- 블로그 -->
            <!-- <li><router-link :to="{ path: '/review' }" :class="{ 'active': currentMenu === 'review' }" @click="toggleMenu; setCurrentMenu('review')">상담후기</router-link></li> -->
            <li><router-link :to="{ path: '/inquiry' }" :class="{ 'active': currentMenu === 'inquiry' }" @click="toggleMenu; setCurrentMenu('inquiry')">문의</router-link></li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
 </template>
<script>
// import router from '@/router';
import { mapGetters } from 'vuex'

export default {
  name: 'SeedJung_Header',
  props: {
    msg: String
  },
  data() {
    return {
      isMobile: false,
      isMenuOpen: false,
      isDropdownOpen: false,
      isAboutSubmenuOpen: false,
      currentMenu: 'home'
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'currentUser']),
    nickname(){
      return this.currentUser ? this.currentUser.nickname : ''
    }
  },
  methods: {
    setCurrentMenu(menu) {
      this.currentMenu = menu;
    },
    toggleMenu() {
      if (this.isMenuOpen && this.currentMenu === 'service') {
        this.isMenuOpen = false;
        this.isAboutSubmenuOpen = false;
      } else {
        this.isMenuOpen = !this.isMenuOpen;
        this.isAboutSubmenuOpen = false;
        this.setCurrentMenu('home');
      }

      if (this.isMenuOpen) {
        document.addEventListener('click', this.handleOutsideClick);
      } else {
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    handleOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.toggleMenu();
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    toggleSubMenu(menu) {
      if (menu === 'about') {
        this.isAboutSubmenuOpen = !this.isAboutSubmenuOpen;
      } else {
        window.location.href = menu;
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
      this.isAboutSubmenuOpen = false;
    },
    logout() {
      this.$router.push('/')
      this.$store.dispatch('logout')
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style>
/* 드롭다운 메뉴의 기본 스타일 */
/* 마우스 오버로 드롭다운 메뉴를 표시합니다 (데스크탑) */
@media (min-width: 769px) {
  .dropdown:hover .dropdown-menu {
    width: 100%;
    display: block;
  }
  .dropdown-menu {
    display: none; /* 기본적으로 숨겨둡니다 */
    position: absolute; /* 위치를 설정합니다 */
    background-color: white;
    list-style: none;
    padding: 0;
    margin: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    z-index: 1000; /* z-index를 높게 설정합니다 */
    border-radius: 8px;
  }

  /* 드롭다운 메뉴 아이템 스타일 */
  .dropdown-menu li {
    padding: 10px 20px;
    border-bottom: 1px solid #ddd;
    text-align: center; /* 글자 가운데 정렬 */
  }

  .dropdown-menu li:last-child {
    border-bottom: none;
  }

  .dropdown-menu li a {
    text-decoration: none;
    color: #333;
    display: block;
    font-size: 16px;
  }
}

/* 드롭다운 메뉴 표시 (모바일) */
.dropdown-menu.show {
  display: block;
  position: static;
  box-shadow: none;
  background-color: #f8f8f8;
}

/* 모바일용 스타일 */
@media (max-width: 768px) {
  .nav-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
  }
  .navbar-brand {
    margin-top: 12px;
  }

  .mobile-menu {
    display: flex;
    align-items: center;
  }

  .logo.center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .head_top_auth.pull-right {
    margin-left: auto;
  }

  .navbar-toggle {
    display: block;
  }

  .main-nav {
    display: none;
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  .main-nav.show {
    display: block;
    animation-name: slideInLeft;
  }
  .nav {
    display: flex;
    flex-direction: column;
    background-color: #f8f8f8; /* 배경색 변경 */
    border-radius: 8px; /* 둥근 모서리 */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 그림자 효과 */
  }

  .nav li {
    /* margin-bottom: 12px; */
    position: relative;
  }

  .nav li a.active {
    background-color: #032f3e; /* 활성화된 메뉴 배경색 */
    color: #fff; /* 활성화된 메뉴 텍스트 색상 */
  }

  .nav li a:hover {
    background-color: #e5e5e5; /* 메뉴 항목 hover 시 배경색 */
  }
  .dropdown-menu {
    display: none;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    /* margin-top: 8px; */
    width: 100%;
    position: absolute;
    /* z-index: 1; */
  }

  .dropdown-menu.show {
    display: block;
  }

  .dropdown-menu li {
    border-bottom: 1px solid #ddd;
    padding: 12px 24px;
  }

  .dropdown-menu li a {
    color: #333;
    font-size: 16px;
    text-decoration: none;
    text-align: center;
  }

  .dropdown-menu li a:hover {
    color: #007bff;
  }
}

/* 로그인 버튼 스타일 (모바일) */
.login-btn {
  padding: 6px 12px;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: #032f3e;
  color: #fff;
  border: none;
  border-radius: 4px;
}

/* 로그인 링크 스타일 (데스크탑) */
.login-link {
  font-size: 14px;
  color: #333;
  text-decoration: none;
  margin-right: 10px;
}

/* 간편가입 버튼 스타일 (데스크탑) */
.signup-btn {
  display: inline-block;
  padding: 8px 16px;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: #072c53;
  color: #fff;
  border: 1px solid #072c53;
  border-radius: 4px;
}

/* 마이페이지 링크 스타일 */
.mypage-link {
  color: #032f3e;
  text-decoration: none;
  margin: 0 10px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.mypage-link:hover {
  background-color: #f0f0f0;
  color: #072c53;
}

/* 웹용 스타일 */
@media (min-width: 769px) {
  .head_top_auth.pull-right {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
}

.login-text {
  font-weight: bold;
  font-size: 15px;
  color: rgb(0, 172, 199)
}

/* 모바일에서의 마이페이지 스타일 */
@media (max-width: 768px) {
  .mypage-link {
    font-size: 15px;
    font-weight: bold;
    color: rgb(0, 172, 199);
  }
}

@keyframes slideInLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>